import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { QuoteQuestionsPageRoutingModule } from './quote-questions-routing.module';

import { QuoteQuestionsPage } from './quote-questions.page';
import { DatetimeModalModule } from 'src/app/components/datetime-modal/datetime-modal.module';

import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AutocompleteModule } from 'src/app/components/autocomplete/autocomplete.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    QuoteQuestionsPageRoutingModule,
    ReactiveFormsModule,
    DatetimeModalModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AutocompleteModule,
  ],
  declarations: [QuoteQuestionsPage],
  providers: [
    provideNgxMask()
  ]
})
export class QuoteQuestionsPageModule {}
